/** @format */

import React from "react";
import Fade from "react-reveal/Fade";
import Tada from "react-reveal/Tada";
import useSettings from "stores/settings";
import Link from "next/link";
import { observer } from "mobx-react-lite";

const market = observer(() => {
  const settings = useSettings();

  return (
    <div>
      <div className="w-full page-1-h">
        <div className="w-full h-full">
          <div className="first-page-content relative">
            <Fade bottom cascade>
              <div>
                <h1 className="w-full text-8xl font-gmarket-bold font-black text-white leading-loose mb-3 keep-words">
                  원하는 인공지능 서비스를
                </h1>
                <h1 className="w-full text-8xl font-gmarket-bold font-black text-white leading-loose mb-3 keep-words">
                  쇼핑하고 즉시 사용해 보세요!
                </h1>
                <div className="w-auto float-left">
                  {settings.login ? (
                    <Link href="/user/market">
                      <a className="ani-btn btn-home">
                        <span></span>
                        <i className="mdi mdi-arrow-right"></i>
                      </a>
                    </Link>
                  ) : (
                    <Link href="/signin">
                      <a className="ani-btn btn-home">
                        <span></span>
                        <i className="mdi mdi-arrow-right"></i>
                      </a>
                    </Link>
                  )}
                </div>
                <div className="w-auto absolute bottom-0 left-1/2 -ml-8">
                  <i className="icon-arrow-down font-bold text-xl text-white center p-4"></i>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </div>
      {/* 마켓 사용법 */}

      <div className="w-full h-full bg-white">
        <div className="page-content pt-20 pb-60">
          <Fade bottom cascade>
            <div className="keep-words mo-text">
              <h3 className="text-555 font-gmarket-medium font-bold pt-28 pb-4">
                <i className="fa fa-question-circle mr-3 text-primary" />
                마켓에서 인공지능 서비스는 어떻게 이용하나요?
              </h3>
              <h1 className="text-333 font-gmarket-bold pb-5">마켓 이용 방법</h1>
            </div>
          </Fade>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/market_use_1.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">01</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">원하는 인공지능 서비스를 찾으세요!</p>
                <p className="text-555 text-lg font-gmarket-medium">
                  아이소 마켓은 자사에서 개발한 인공지능 뿐만 아니라 전 세계의 개발자들이 개발한 다양한 인공지능 서비스를 거래하고 있습니다.
                </p>
              </div>
            </div>
          </Fade>
          <div className="center text-4xl text-gray-300 py-5">
            <i className="fa fa-arrow-circle-down"></i>
          </div>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/market_use_2.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">02</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">인공지능 서비스 앱을 사용해 보세요!</p>
                <p className="text-555 text-lg font-gmarket-medium">찾은 인공지능 서비스 앱을 클릭하면 사용이 가능한 화면이 나타납니다.</p>
              </div>
            </div>
          </Fade>
          <div className="center text-4xl text-gray-300 py-5">
            <i className="fa fa-arrow-circle-down"></i>
          </div>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/market_use_3.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">03</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">결과물을 다운로드 받고 공유해 보세요!</p>
                <p className="text-555 text-lg font-gmarket-medium">업로드한 파일 결과를 다운 받고 다른 사용자들과 공유해 보세요!</p>
              </div>
            </div>
          </Fade>
        </div>
        <div className="center py-20 keep-words bg-indigo-100">
          <h1 className="text-000 font-gmarket-medium font-bold tracking-widest pb-2">필요한 서비스 앱을 찾지 못하셨나요?</h1>
          <Tada>
            <h1 className="text-000 font-gmarket-medium font-bold tracking-widest pb-3">개발자에게 의뢰해 보세요!</h1>
          </Tada>
          <p className="text-333 text-lg font-gmarket-medium mb-5">
            내가 찾던 인공지능 서비스와 유사한 서비스를 제작한 개발자에게 의뢰를 문의해보세요.
          </p>
          {settings.login ? (
            <Link href="/user/market">
              <button type="" className="btn glass_in_btn text-base font-gmarket-medium">
                아이소 마켓 바로가기
                <i className="mdi mdi-arrow-right ml-2"></i>
              </button>
            </Link>
          ) : (
            <Link href="/signin">
              <button type="" className="btn glass_in_btn text-base font-gmarket-medium">
                아이소 마켓 바로가기
                <i className="mdi mdi-arrow-right ml-2"></i>
              </button>
            </Link>
          )}
        </div>
      </div>

      {/* 데이터 분석 사용법 */}
      {/* <div className="w-full h-full bg-gray-input">
        <div className="page-content py-20">
          <Fade bottom cascade>
            <div className="keep-words mo-text">
              <h3 className="text-555 font-gmarket-medium font-bold pt-28 pb-4">
                <i className="fa fa-question-circle mr-3 text-primary" />
                데이터 분석으로 인공지능 서비스를 어떻게 사용하나요?
              </h3>
              <h1 className="text-333 font-gmarket-bold pb-5">데이터 분석 이용 방법 (CSV)</h1>
            </div>
          </Fade>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/data_use_1.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">01</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">원하는 데이터 분석 서비스를 찾으세요!</p>
                <p className="text-555 text-lg font-gmarket-medium">
                  아이소 데이터 분석에서는 예측, 통계, 분석 등 다양한 데이터 인공지능 분석 서비스를 거래하고 있습니다!
                </p>
              </div>
            </div>
          </Fade>
          <div className="center text-4xl text-gray-300 py-5">
            <i className="fa fa-arrow-circle-down"></i>
          </div>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/data_use_2-1.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">02</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                  데이터 분석 앱의 정보를 확인하세요!
                  <br /> : 컬럼 설명
                </p>
                <p className="text-555 text-lg font-gmarket-medium">
                  컬럼의 이름, 그에 따른 데이터 타입 과 설명을 확인 할 수 있고, 어떤 결과 컬럼이 사용되었는지 알 수 있습니다.
                </p>
              </div>
            </div>
          </Fade>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/data_use_2-2.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5"></h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                  데이터관련 상세 정보를 알아보세요!
                  <br />: 데이터 분석
                </p>
                <p className="text-555 text-lg font-gmarket-medium">
                  사용된 데이터에 대한 상세 정보 와 컬럼별 특징에 대한 상세 정보를 알 수 있습니다.
                </p>
              </div>
            </div>
          </Fade>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/data_use_2-3.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5"></h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                  사용된 알고리즘과 정확도를 알아보세요!
                  <br />: 알고리즘
                </p>
                <p className="text-555 text-lg font-gmarket-medium">
                  학습유형, 사용된 알고리즘, 타겟, 학습에 영향을 준 특징들, 정확도 를 알 수 있습니다.
                </p>
              </div>
            </div>
          </Fade>
          <div className="center text-4xl text-gray-300 py-5">
            <i className="fa fa-arrow-circle-down"></i>
          </div>
          <Fade bottom cascade>
            <div className="my-14">
              <Slider {...setting} className="p-0 m-0 visitor-slider">
                <div className="w-full">
                  <div className="w-full mb-32">
                    <div className="md:flex md:justify-center md:items-center rounded-visitor-market">
                      <div className="w-full md:w-1/2">
                        <div className="img-cover-box">
                          <img src="/images/visitor/data_use_3-1-1.png" alt="" />
                        </div>
                      </div>
                      <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words">
                        <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">
                          03-<span className="text-4xl">1</span>
                        </h1>
                        <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                          나의 데이터를 분석해 보세요!
                          <br />: 파일 업로드
                        </p>
                        <p className="text-555 text-lg font-gmarket-medium">
                          나의 CSV 파일을 업로드하여 분석합니다. 데이터 파일이 없을시 아이소에서 제공하는 CSV 파일을 사용해 테스트가
                          가능합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="w-full">
                    <div className="md:flex md:justify-center md:items-center rounded-visitor-market">
                      <div className="w-full md:w-1/2">
                        <div className="img-cover-box">
                          <img src="/images/visitor/data_use_3-1-2.png" alt="" />
                        </div>
                      </div>
                      <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words">
                        <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5"></h1>
                        <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                          분석 결과 다운로드!
                          <br />: 파일 업로드
                        </p>
                        <p className="text-555 text-lg font-gmarket-medium">나의 데이터 분석 결과를 다운받아 확인해 보세요.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full">
                  <div className="w-full mb-32">
                    <div className="md:flex md:justify-center md:items-center rounded-visitor-market">
                      <div className="w-full md:w-1/2">
                        <div className="img-cover-box">
                          <img src="/images/visitor/data_use_3-2-1.png" alt="" />
                        </div>
                      </div>
                      <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words">
                        <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">
                          03-<span className="text-4xl">2</span>
                        </h1>
                        <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                          나의 데이터를 분석해 보세요!
                          <br />: 데이터 입력
                        </p>
                        <p className="text-555 text-lg font-gmarket-medium">데이터를 직접 입력하여 간단한 테스트를 할 수 있습니다.</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-full">
                    <div className="md:flex md:justify-center md:items-center rounded-visitor-market">
                      <div className="w-full md:w-1/2">
                        <div className="img-cover-box">
                          <img src="/images/visitor/data_use_3-2-2.png" alt="" />
                        </div>
                      </div>
                      <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words">
                        <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5"></h1>
                        <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">
                          데이터 분석 결과 확인!
                          <br />: 데이터 입력
                        </p>
                        <p className="text-555 text-lg font-gmarket-medium">
                          내가 선택한 컬럼(결과 컬럼)의 분석 결과가 화면에 표시되어 간단하게 확인이 가능합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </Fade>
          <Fade bottom cascade>
            <div className="md:flex md:justify-center md:items-center rounded-visitor-market my-14">
              <div className="w-full md:w-1/2">
                <div className="img-cover-box">
                  <img src="/images/visitor/data_use_4.png" alt="" />
                </div>
              </div>
              <div className="w-full md:w-1/2 py-5 px-6 sm:px-14 md:px-20 xl:px-28 keep-words">
                <h1 className="text-gray-300 font-gmarket-bold tracking-widest pb-4 sm:pb-5">04</h1>
                <p className="text-333 text-2xl font-gmarket-medium font-bold pb-3">사용한 데이터 분석 앱을 공유해보세요!</p>
                <p className="text-555 text-lg font-gmarket-medium">
                  내가 사용했던 분석 앱이 마음에 들면 다른 사용자 또는 지인에게 공유해 보세요!
                </p>
              </div>
            </div>
          </Fade>
        </div>
      </div> */}
      {/* <div className="w-full h-full bg-gray-200 sm:px-28 py-10">
        <div className="page-content center keep-words">
          <h3 className="font-gmarket-medium font-bold mb-0 text-555 pt-4 pb-5">원하는 인공지능 서비스를 쇼핑하시겠습니까?</h3>
          {settings.login ? (
            <Link href="/user/market">
              <button type="" className="btn btn-outline-primary text-base font-gmarket-medium">
                아이소 마켓 바로가기
                <i className="mdi mdi-arrow-right ml-2"></i>
              </button>
            </Link>
          ) : (
            <Link href="/signin">
              <button type="" className="btn btn-outline-primary text-base font-gmarket-medium">
                아이소 마켓 바로가기
                <i className="mdi mdi-arrow-right ml-2"></i>
              </button>
            </Link>
          )}
        </div>
      </div> */}
    </div>
  );
});

export default market;
